import React from 'react'
import styled from 'styled-components'
import { mobileSize } from 'theme'
import PointSvg from '/static/images/ic-point-light-blue.svg'
import { cent2dollar } from '@hk01-digital/wallet-internal-sdk'
import { formatNumerics } from 'utils/formatUtil'

const BuySkuAmount = ({ pointsValue, amount: exchangePrice }) => {
  const formatAmount = formatNumerics(cent2dollar(exchangePrice))
  return (
    <AmountWrapper>
      {exchangePrice > 0 && <span>${formatAmount}</span>}
      {!!pointsValue && (
        <>
          {exchangePrice > 0 && <AddSpan>+</AddSpan>}
          <PointIcon />
          {formatNumerics(pointsValue)}
        </>
      )}
      {!(exchangePrice || pointsValue) && <FreePointLabel>免费</FreePointLabel>}
    </AmountWrapper>
  )
}

const AmountWrapper = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${(p) => p.theme.color.blue200};
  display: flex;
  align-items: center;
  @media ${mobileSize} {
    font-size: 16px;
  }
`

export const AddSpan = styled.span`
  font-size: 12px;
  font-weight: normal;
  padding: 0 2px;
`
export const PointIcon = styled(PointSvg)`
  width: 16px;
  height: 18px;
  margin-right: 2px;
`
export const FreePointLabel = styled.label`
  font-size: 18px;
  @media ${mobileSize} {
    font-size: 14px;
  }
`

export default BuySkuAmount
